// PrivacyPolicy.jsx
import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Switch, Select,Radio,Space,InputNumber,Button, Checkbox, Row } from 'antd';
import { BreathAPIs } from '../../APIs/BreathAPIs';
import { toast } from 'react-toastify';
import { ButtonCustom } from '../../BootstrapComponents/ButtonCustom';
import DynamicRanges from "./DynamicTimeRanges"
import styles from "./styles.module.css"

import { BsPlusCircleDotted } from "react-icons/bs";
import DynamicTimeRangeAddition from './DynamicTimeRangeAddition';
import { BiSolidMinusCircle } from "react-icons/bi";

const EditLocation = ({ modalVisible, closeModal, submitFeedback, allLocations, selLocation }) => {
    const handleCancel = () => {
        closeModal();
        setTempRevenueModel({revenueType:null,PPA:null,MUFA:null,MUFChargerCount:null,RSF:null,startDate:null,endDate:null})
    };
    // console.log("all loc", allLocations)
    // console.log("selLocation", selLocation)
    // console.log("selLocation rate type", selLocation.rateType)
    // console.log('sel location revenue model:',selLocation.revenueModel);

    // console.log("selected location : ", selLocation)

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [chargerData, setChargerData] = useState([])
    const [chargerDynamicRate, setChargerDynamicRate] = useState([])
    const [notifyUsers, setNotifyUsers] = useState(false)
    const [updateCommissioningDate, setUpdateCommissioningDate] = useState(false)

    // const [chargerAllocationConfiguration,setChargerAllocationConfiguration] = useState(null);

    // const [chargerDynamicRatestate, setChargerDynamicRateState] = useState(chargerDynamicRates)
    // const [rateType, setRateType] = useState("fixed")
    const [rateType, setRateType] = useState(selLocation.rateType ? selLocation.rateType : "fixed")
    const [isDynamicRateAddFieldVisible, setIsDynamicRateAddfieldVisible] = useState(false)
    const [isSharedFieldVisible, setIsSharedFieldVisible] = useState(false)
    const [sharedTimeField,setSharedTimeField] = useState([]);
    const [tempRevenueModel,setTempRevenueModel] = useState({revenueType:null,PPA:null,RSF:null,MUFA:null,MUFChargerCount:null, startDate:null,endDate:null})
    const [tempMiscRevModel,setTempMiscRevModel] = useState({miscRevShare:[],miscRevShareFactor:[0,0,0,0],startDate:null,endDate:null})
    const [tempTransactionFeeModel,setTempTransactionFeeModel] = useState({transactionFee:0,transactionFeeFactor:0,startDate:null,endDate:null})
    // const [normalRate, setNormalRate] = useState(0)

    const [isAbsRevShare,setIsAbsRevShare] = useState(selLocation.absoluteRevShare > 0 ? "yes" :"no");
    
    const [rate,setRate] = useState(
        (
            selLocation.absoluteRevShare > 0 &&
            selLocation.revenueModel[selLocation.revenueModel.length - 1].revenueType === "rev_share")
            ? selLocation.absoluteRevShare / (1 - selLocation.revenueModel[selLocation.revenueModel.length - 1].RSF) : 0);
    // Add a state to store location data 
    console.log("child loc default set: ", allLocations.filter((loc) => loc?.parentLocation?.some(id => String(id) === String(selLocation._id))).map((loc) => loc._id) ?? [])
    const [locationData, setLocationData] = useState({
        locationName: '',
        active: true,
        operatorName: '',
        public: false,
        rateType: '',
        chargerAllocationConfiguration:'',
        locationType:'',
        sharedTime:[],
        splitFactor:0,
        selectCharger:null,
        unutilizationThreshold:null,
        unutilizationFeePercent:null,
        maxChargeDuration:0,
        minChargeDuration: 0,
        gracePeriodInMinutes: 0,
        idleFee:0,
        power:null,
        normalRate: null,
        taxAmount: null,
        revenueModel:[],
        bookableDaysLimit: 1,
        relatedLocations:[],
        childLocations: allLocations.filter((loc) => loc?.parentLocation?.some(id => String(id) === String(selLocation._id))).map((loc) => loc._id) ?? [],
        miscRevModel:[],
        transactionFeeModel:[],
        enableThirdPartyRedirect: false,
        thirdPartyRedirectUrl: '',
        redirectCodeId: '',
        guestUserAccessible: false,
        companies: [],
        showRateSplitInfo: false,
        showInMapView: false,
        overNightChargingEnabled: false,
        userMaxDurationLimit: false
    });

    // Fetch charger data and update the dynamic rate
    const getChargerData = async () => {
        try {
            const res = await BreathAPIs.getChargerList({ location_id: selLocation?._id });
            // console.log("charger get api response: ", res.data.chargers);
            setChargerData(res.data.chargers);
            // setNormalRate(res.data.chargers[0].rate.price_component.price)
            setLocationData(prev => ({ ...prev, normalRate: res.data.chargers[0]?.rate.price_components.price, taxAmount: res.data.chargers[0]?.rate.price_components.tax }))
            // Directly use the fetched data to set chargerDynamicRate
            if (res.data.chargers[0]?.dynamicRates) {
                setChargerDynamicRate(res.data.chargers[0].dynamicRates);
            } else {
                setChargerDynamicRate([]); // Ensure it's an empty array if no rates exist
            }
        } catch (error) {
            console.error("Error fetching charger data:", error);
        }
    };


    const changeChargerRateType = (checkedVal) => {
        setRateType(checkedVal ? 'dynamic' : 'fixed');

    };

    const handleRevenueModelChange = (attribute,value) => {
        if ( attribute === 'revenueType'){

           if(value==='rev_share'){
            setTempRevenueModel
            ({
                revenueType: value,
                PPA: 0,
                RSF: (selLocation.absoluteRevShare > 0 && isAbsRevShare === 'yes') ?
                    1 - (selLocation.absoluteRevShare / locationData.normalRate)
                    :
                    0,
                startDate: null,
                endDate: null
            })
           }
           if(value==='per_port'){
            setTempRevenueModel({revenueType:value,PPA:0,RSF:1.0,startDate:null,endDate:null})
           }
           if(value==='hybrid'){
            setTempRevenueModel({revenueType:value,PPA:0,RSF:0,startDate:null,endDate:null})
           }
           if(value==='muf'){
            setTempRevenueModel({revenueType:value,PPA:0,RSF:0,MUFA:0,MUFChargerCount:0,startDate:null,endDate:null})
           }

        }

        if(attribute==='PPA'){
            setTempRevenueModel((prev)=>({...prev,PPA:value })) 
        }
        if(attribute==='RSF'){
            setTempRevenueModel((prev)=>({...prev,RSF:value })) 
        }
        if(attribute === 'MUFRate'){
            setTempRevenueModel((prev)=>({...prev,MUFA:value }) )
        }
        if(attribute === 'MUFChargerCount'){
            setTempRevenueModel((prev)=>({...prev,MUFChargerCount:value }) )
        }

    };

    const handleMiscRevModelChange = (value, attribute) => {
        if(attribute === 'miscRevShare'){
            setTempMiscRevModel(
                {
                    miscRevShare: value,
                    miscRevShareFactor: 0,
                    startDate: new Date(),
                    endDate: null
                }
            )
        } 
        if(attribute === 'miscRevShareFactor'){
            let miscArray = ["I_Fee","U_Fee","C_Fee","O_Fee"]
            let miscFactorArray = [value, value, value, value]
            setTempMiscRevModel((prev)=>({...prev,miscRevShareFactor:miscFactorArray,miscRevShare:miscArray}) )
            // setTempMiscRevModel((prev)=>({...prev,miscRevShare:miscArray}) )
        }
        if(attribute === 'miscRevShareFactorI'){
            let miscFactorArray = tempMiscRevModel.miscRevShareFactor
            miscFactorArray[0] = value
            setTempMiscRevModel((prev)=>({...prev,miscRevShareFactor:miscFactorArray}) )
        }
        if(attribute === 'miscRevShareFactorU'){
            let miscFactorArray = tempMiscRevModel.miscRevShareFactor
            miscFactorArray[1] = value
            setTempMiscRevModel((prev)=>({...prev,miscRevShareFactor:miscFactorArray}) )
        }
        if(attribute === 'miscRevShareFactorC'){
            let miscFactorArray = tempMiscRevModel.miscRevShareFactor
            miscFactorArray[2] = value
            setTempMiscRevModel((prev)=>({...prev,miscRevShareFactor:miscFactorArray}) )
        }
        if(attribute === 'miscRevShareFactorO'){
            let miscFactorArray = tempMiscRevModel.miscRevShareFactor
            miscFactorArray[3] = value
            setTempMiscRevModel((prev)=>({...prev,miscRevShareFactor:miscFactorArray}) )
        }
    }

    const handleTransactionFeeModelChange = (value, attribute) => {
        setTempTransactionFeeModel((prev)=>({...prev,startDate:new Date(),endDate:null}))
        if(attribute === 'transactionFee'){
            setTempTransactionFeeModel((prev)=>({...prev,transactionFee:value}))
        }
        if(attribute === 'transactionFeeFactor'){
            setTempTransactionFeeModel((prev)=>({...prev,transactionFeeFactor:value}))
        }

    }
    const pushRevenueModelChange = () => {

        console.log('selLocation rev model length:',selLocation.revenueModel.length);
        console.log('location data rev model length:',locationData.revenueModel.length);
        
        if(selLocation.revenueModel.length - locationData.revenueModel.length === 0){
            let finalLocationData = locationData;
            finalLocationData.revenueModel[finalLocationData.revenueModel.length - 1].endDate = new Date();
            finalLocationData.revenueModel.push({...tempRevenueModel,startDate:new Date(finalLocationData.revenueModel[finalLocationData.revenueModel.length - 1].endDate.getTime() + 1) })
            setLocationData(finalLocationData);

        }
        else{
            console.log('Inside else condition')
            let finalLocationData = locationData;
            finalLocationData.revenueModel[finalLocationData.revenueModel.length - 2].endDate = new Date();
            finalLocationData.revenueModel[finalLocationData.revenueModel.length - 1] = {...tempRevenueModel,startDate:new Date(finalLocationData.revenueModel[finalLocationData.revenueModel.length - 1].endDate.getTime() + 1)};
            // finalLocationData.revenueModel.push({...tempRevenueModel,startDate:new Date(finalLocationData.revenueModel[finalLocationData.revenueModel.length - 1].endDate.getTime() + 1) })
            setLocationData(finalLocationData);
        }

    };


    useEffect(() => {
        // console.log("selLocation", selLocation)
        // console.log("location selection useeffect")
        // setSplitFactorValue();
        console.log("...........................................................")
        console.log("selected location: ", selLocation)
            console.log("all locs: ", allLocations)
            console.log("child loc sel loc useeffect set: ", allLocations.filter((loc) => loc?.parentLocation?.some(id => String(id) === String(selLocation._id))).map((loc) => loc._id) ?? [])
        
        if (selLocation && allLocations.length > 0) {
            
            setLocationData({
                _id: selLocation?._id,
                locationName: selLocation?.locationName,
                active: selLocation?.active,
                operatorName: selLocation?.operatorName,
                public: selLocation?.public,
                rateType: rateType,
                chargerAllocationConfiguration:selLocation?.chargerAllocationConfiguration,
                locationType: selLocation?.locationType,
                splitFactor:selLocation?.splitFactor,
                sharedTime:selLocation?.sharedTime,
                selectCharger:selLocation?.selectCharger,
                unutilizationThreshold:selLocation?.unutilizationThreshold,
                unutilizationFeePercent:selLocation?.unutilizationFeePercent,
                maxChargeDuration:selLocation?.maxChargeDuration,
                minChargeDuration: selLocation?.minChargeDuration ?? 0.25,
                gracePeriodInMinutes: selLocation?.gracePeriodInMinutes ?? 10,
                idleFee:selLocation?.idleFee,
                revenueModel:selLocation?.revenueModel,
                bookableDaysLimit: selLocation?.bookableDaysLimit ?  selLocation?.bookableDaysLimit : 1,
                relatedLocations: selLocation?.relatedLocations ? selLocation.relatedLocations : [],
                absoluteRevShare: selLocation?.absoluteRevShare ? selLocation?.absoluteRevShare : 0,
                miscRevModel:selLocation?.miscRevModel,
                childLocations: allLocations.filter((loc) => loc?.parentLocation?.some(id => String(id) === String(selLocation._id))).map((loc) => loc._id) ?? [],
                transactionFeeModel: selLocation?.transactionFeeModel ? selLocation.transactionFeeModel : [],
                enableThirdPartyRedirect: selLocation?.enableThirdPartyRedirect ?? false,
                thirdPartyRedirectUrl: selLocation?.thirdPartyRedirectUrl ?? '',
                redirectCodeId: selLocation?.redirectCodeId ?? '',
                guestUserAccessible: selLocation?.guestUserAccessible ?? false,
                companies: selLocation?.companies ?? [],
                showRateSplitInfo: selLocation?.showRateSplitInfo ?? false,
                showInMapView: selLocation?.showInMapView ?? false,
                overNightChargingEnabled: selLocation?.overNightChargingEnabled ?? false,
                userMaxDurationLimit: selLocation?.userMaxDurationLimit ?? false,
                // power:selLocation?.power || 0

            });
            setTempMiscRevModel(selLocation?.miscRevModel && selLocation.miscRevModel.length > 0 ? 
                selLocation.miscRevModel[selLocation.miscRevModel.length -1] : 
                {miscRevShare:[],miscRevShareFactor:[0,0,0],startDate:null,endDate:null})
            setTempRevenueModel(selLocation?.revenueModel[selLocation.revenueModel.length - 1])
            setTempTransactionFeeModel(selLocation?.transactionFeeModel && selLocation.transactionFeeModel.length > 0 ?
                selLocation.transactionFeeModel[selLocation.transactionFeeModel.length - 1] :
                {transactionFee:0,transactionFeeFactor:0,startDate:null,endDate:null})
            // chargerData.length === 0 ? getChargerData() : console.log("charger data already fetched.")
            // if (rateType === "dynamic") {
                getChargerData()
            // }

            // console.log("chargerData", chargerData[0])
            // console.log(chargerData[0]?.dynamicRates)
            setSharedTimeField(selLocation.sharedTime?selLocation.sharedTime:[])

          
        }
    }, [selLocation, rateType, allLocations]);

    const { Option } = Select;
    const [form] = Form.useForm();

    const setLocationType = (checked)=>{
        let modifiedLocationType = locationData.locationType
        if (checked){
            if (locationData.public){
                modifiedLocationType = "SHARED-PUBLIC"
            }else{
                modifiedLocationType = "SHARED-PRIVATE"
            }
        }else{
            if (locationData.public){
                modifiedLocationType = "PUBLIC"
            }else{
                modifiedLocationType = "PRIVATE"
            }
        }
        setLocationData((prev)=>({...prev, locationType:modifiedLocationType}))
    }
    
    const setLocationVisibility = (checked) =>{
        if(checked){
            if(locationData.locationType === "SHARED-PUBLIC" || locationData.locationType === "SHARED-PRIVATE"){
                setLocationData((prev)=>({...prev, locationType:"SHARED-PUBLIC", public:checked}))
            }else{
                setLocationData((prev)=>({...prev, locationType:"PUBLIC", public:checked}))
            }
        }else{
            if(locationData.locationType === "SHARED-PUBLIC" || locationData.locationType === "SHARED-PRIVATE"){
                setLocationData((prev)=>({...prev, locationType:"SHARED-PRIVATE", public:checked}))
            }else{
                setLocationData((prev)=>({...prev, locationType:"PRIVATE", public:checked}))
            }
        }
    }

    const isValidUrl = (url) => {
        if (!url) return false;
        try {
            const parsed = new URL(url);
            return parsed.protocol === 'http:' || parsed.protocol === 'https:';
        } catch (error) {
            return false;
        }
    };

    const userSubmit = async () => {
        if (locationData.enableThirdPartyRedirect && !isValidUrl(locationData.thirdPartyRedirectUrl)) {
            toast.error('Please enter a valid third party redirect URL.');
            return;
        }
        try {
            setIsSubmitting(true);
            // console.log('Viewing location data shared time before submit: ',locationData.sharedTime);
            // console.log('location charger power check: ',locationData);
            // console.log('temp revenue model before submit:',tempMiscRevModel);
            // console.log('temp misc rev model before submit:',selLocation.miscRevModel);
            let tempMiscRevArray = tempMiscRevModel.miscRevShare?.sort();
            let tempRevShareFactor = tempMiscRevModel.miscRevShareFactor;
            let miscRevShareArray = selLocation.miscRevModel && selLocation.miscRevModel.length > 0 ? selLocation.miscRevModel[selLocation.miscRevModel.length -1].miscRevShare?.sort() : [];
            let miscRevShareFactor = selLocation.miscRevModel && selLocation.miscRevModel.length > 0 ? selLocation.miscRevModel[selLocation.miscRevModel.length -1].miscRevShareFactor : [0,0,0];
            console.log('temp misc rev array:',JSON.stringify(tempMiscRevArray) !== JSON.stringify(miscRevShareArray) ||
                JSON.stringify(tempRevShareFactor) !== JSON.stringify(miscRevShareFactor));
            //     console.log('temp misc rev array:',tempMiscRevArray);
            // console.log('misc rev share array:',miscRevShareArray);
            // console.log('temp rev share factor:',tempRevShareFactor);
            // console.log('misc rev share factor:',miscRevShareFactor);
            let res
            let finalLocationData = locationData;
            if(selLocation.revenueModel[selLocation.revenueModel.length - 1 ].revenueType !== tempRevenueModel.revenueType ||
                selLocation.revenueModel[selLocation.revenueModel.length - 1 ].PPA !== tempRevenueModel.PPA ||
                selLocation.revenueModel[selLocation.revenueModel.length - 1 ].RSF !== tempRevenueModel.RSF ||
                selLocation.revenueModel[selLocation.revenueModel.length - 1 ].MUFA !== tempRevenueModel.MUFA ||
                selLocation.revenueModel[selLocation.revenueModel.length - 1 ].MUFChargerCount !== tempRevenueModel.MUFChargerCount
             ){

                 
                 finalLocationData.revenueModel[finalLocationData.revenueModel.length - 1].endDate = new Date();
                 finalLocationData.revenueModel.push({...tempRevenueModel,startDate:new Date(finalLocationData.revenueModel[finalLocationData.revenueModel.length - 1].endDate.getTime() + 1) })
                //  console.log('final location revenue model: ',finalLocationData.revenueModel);
                //   res = await BreathAPIs.updateLocation(finalLocationData, chargerDynamicRate, notifyUsers, updateCommissioningDate);
            } 
            // else {
            //     // res = await BreathAPIs.updateLocation(locationData, chargerDynamicRate, notifyUsers, updateCommissioningDate);
            // }
                
            if
                (
                JSON.stringify(tempMiscRevArray) !== JSON.stringify(miscRevShareArray) ||
                JSON.stringify(tempRevShareFactor) !== JSON.stringify(miscRevShareFactor)
            ) {
                // let finalLocationData = locationData;
                console.log("Condition matched for misc rev model update", finalLocationData.miscRevModel && finalLocationData.miscRevModel?.length > 0)
                if(finalLocationData.miscRevModel && finalLocationData.miscRevModel?.length > 0){
                    finalLocationData.miscRevModel[finalLocationData.miscRevModel.length - 1].endDate = new Date()
                    finalLocationData.miscRevModel.push(
                        {
                            ...tempMiscRevModel,
                            startDate:new Date(finalLocationData.miscRevModel[finalLocationData.miscRevModel.length - 1].endDate.getTime() + 1)
                        }
                    )
                    
                } 
                else{
                    finalLocationData.miscRevModel = tempMiscRevModel
                    finalLocationData.miscRevModel.startDate = new Date()
                }
                // console.log('final location misc rev model: ',finalLocationData.miscRevModel);
                // res = await BreathAPIs.updateLocation(finalLocationData, chargerDynamicRate, notifyUsers, updateCommissioningDate);
            }
            // else {
            //     res = await BreathAPIs.updateLocation(locationData, chargerDynamicRate, notifyUsers, updateCommissioningDate);
            //  }
            if((selLocation.transactionFeeModel && selLocation.transactionFeeModel.length >= 1) && (
                tempTransactionFeeModel.transactionFee !== selLocation.transactionFeeModel[selLocation.transactionFeeModel.length - 1]?.transactionFee || 
                tempTransactionFeeModel.transactionFeeFactor !== selLocation.transactionFeeModel[selLocation.transactionFeeModel.length - 1]?.transactionFeeFactor
            )){
                finalLocationData.transactionFeeModel[finalLocationData.transactionFeeModel.length - 1].endDate = new Date();
                finalLocationData.transactionFeeModel.push(
                    {
                        ...tempTransactionFeeModel,
                        startDate:new Date(finalLocationData.transactionFeeModel[finalLocationData.transactionFeeModel.length - 1].endDate.getTime() + 1)
                    }
                )
            }else{
                finalLocationData.transactionFeeModel = [
                    {
                        ...tempTransactionFeeModel,
                        startDate:new Date()
                    }
                ]
            }
            res = await BreathAPIs.updateLocation(finalLocationData, chargerDynamicRate, notifyUsers, updateCommissioningDate);
            form.resetFields();
            submitFeedback(res?.data?.message);
            setTempRevenueModel({revenueType:null,PPA:null,RSF:null,startDate:null,endDate:null})
            setTempMiscRevModel({miscRevShare:[],miscRevShareFactor:[0,0,0],startDate:null,endDate:null})
            setIsSubmitting(false);
            closeModal();
        } catch (error) {
            toast.error('Error updating location.');
            console.log(error);
            setIsSubmitting(false);
        }
    };


    const getUpdatedDynamicRates = (updatedDynamicRates) => {
        console.log("updated dynamic rates: ", updatedDynamicRates)
        setChargerDynamicRate(updatedDynamicRates)
    }
    const getUpdatedSharedTime = (updatedSharedTime)=>{
        console.log('Updated shared time:',updatedSharedTime);
        setSharedTimeField(updatedSharedTime);

    }

    return (
        <Modal
        title="Edit Location"
        visible={modalVisible}
        onCancel={handleCancel}
        footer={null}
        width={window.innerWidth <= 768 ? '100%' : '50%'}
        
        >
            {/* {console.log('location data:',locationData)}
            {console.log('selLocation data:',selLocation)} */}

            <Form form={form} onFinish={userSubmit} layout={'vertical'} initialValues={locationData}>

                <div className={styles.flexContainer}>
                <Form.Item label="Active" valuePropName="checked">
                    <Switch checked={locationData.active} onChange={(checked) => {setLocationData((prev) => ({ ...prev, active: checked }));
                    setUpdateCommissioningDate(checked ? updateCommissioningDate : false);
                    setNotifyUsers(checked ? notifyUsers : false)}} />
                </Form.Item>

            {selLocation.active === false && <Form.Item label="Notify Users" valuePropName="checked">
                <Switch 
                disabled = {!locationData.active}
                checked={notifyUsers} 
                onChange={(checked) => setNotifyUsers(checked)}
                    />
            </Form.Item>}
            {selLocation.active === false && <Form.Item label="Update Commissioning Date" valuePropName="checked">
                <Switch 
                disabled = {!locationData.active}
                checked={updateCommissioningDate} 
                onChange={(checked) => setUpdateCommissioningDate(checked)}
                    />
            </Form.Item>}

                {/* <Form.Item label="Split Factor">
                      
                        <InputNumber
                            min={0}
                            max={1}
                            step={0.1}
                            value = {parseFloat(locationData.splitFactor)}
                             onChange={(value) => setLocationData(prev => ({ ...prev, splitFactor: value }))}
                         
                        />
                </Form.Item> */}

                </div>
                
                  


                <Form.Item label="Location Name">
                    <Input value={locationData.locationName} onChange={(e) => setLocationData((prev) => ({ ...prev, locationName: e.target.value }))} />
                </Form.Item>


                <Form.Item label="Operator Name">
                    <Input value={locationData.operatorName} onChange={(e) => setLocationData((prev) => ({ ...prev, operatorName: e.target.value }))} />
                </Form.Item>

                <Form.Item label="Redirect to Third Party on Scan" valuePropName="checked">
                    <Switch checked={locationData.enableThirdPartyRedirect} onChange={(checked) => setLocationData((prev) => ({ ...prev, enableThirdPartyRedirect: checked }))} />
                </Form.Item>

                {locationData.enableThirdPartyRedirect && <Form.Item
                    label="Third Party Redirect URL"
                    rules={[{ required: true, message: "Please enter a valid redirect URL!" }]}
                    validateStatus={isValidUrl(locationData.thirdPartyRedirectUrl) ? '' : 'error'}
                    help={isValidUrl(locationData.thirdPartyRedirectUrl) ? '' : 'Enter a valid http(s) URL'}
                >
                    <Input placeholder="https://example.com/validate" value={locationData.thirdPartyRedirectUrl} onChange={(e) => setLocationData((prev) => ({ ...prev, thirdPartyRedirectUrl: e.target.value }))} />
                </Form.Item>}

                {locationData.enableThirdPartyRedirect && <Form.Item label="Redirect QR Code ID">
                    <Input value={locationData.redirectCodeId || 'Will be generated on save'} disabled />
                </Form.Item>}

                <Form.Item label="Guest User Accessible" valuePropName="checked">
                    <Switch checked={locationData.guestUserAccessible} onChange={(checked) => setLocationData((prev) => ({ ...prev, guestUserAccessible: checked }))} />
                </Form.Item>

                <div className={styles.flexContainer}>
                <Form.Item label="Show Rate Split Info" valuePropName="checked">
                    <Switch checked={locationData.showRateSplitInfo} onChange={(checked) => setLocationData((prev) => ({ ...prev, showRateSplitInfo: checked }))} />
                </Form.Item>

                <Form.Item label="Show In Map View" valuePropName="checked">
                    <Switch checked={locationData.showInMapView} onChange={(checked) => setLocationData((prev) => ({ ...prev, showInMapView: checked }))} />
                </Form.Item>

                <Form.Item label="Overnight Charging Enabled" valuePropName="checked">
                    <Switch checked={locationData.overNightChargingEnabled} onChange={(checked) => setLocationData((prev) => ({ ...prev, overNightChargingEnabled: checked }))} />
                </Form.Item>

                <Form.Item label="User Max Duration Limit" valuePropName="checked">
                    <Switch checked={locationData.userMaxDurationLimit} onChange={(checked) => setLocationData((prev) => ({ ...prev, userMaxDurationLimit: checked }))} />
                </Form.Item>
                </div>

                <Form.Item label="Companies">
                    <Select
                        mode='tags'
                        allowClear
                        value={locationData.companies}
                        onChange={(value) => setLocationData((prev) => ({ ...prev, companies: value }))}
                        placeholder='Type a company and press Enter'
                        tokenSeparators={[',']}
                    />
                </Form.Item>

                <Form.Item label="Idle Fee ( per min )">
                        <InputNumber
                            min={0}
                            value = {locationData.idleFee}
                            onChange={(value) => setLocationData(prev => ({ ...prev, idleFee: value }))}
                            style={{'width':'100%'}}
                        />
                </Form.Item>

                <Form.Item label="Update Charger(s) Power ( Optional )">
                        <InputNumber
                            style={{ width: '100%' }}
                            min={0}
                            value = {locationData.power}
                            onChange={(value) => setLocationData(prev => ({ ...prev, power: value }))}
                            disabled={ chargerData.length === 0 }
                        />
                </Form.Item>
                {/* {console.log("location data in form: ", locationData)} */}
                <Form.Item label="Normal Energy Rate (per kWh)">
                        <InputNumber
                            style={{ width: '100%' }}
                            min={0}

                            value = {locationData.normalRate}
                            onChange={(value) => {
                                setLocationData(prev => ({ ...prev, normalRate: value }))
                                
                                if(locationData.absoluteRevShare > 0 && isAbsRevShare === 'yes' && locationData.revenueModel[locationData.revenueModel.length - 1].revenueType === 'rev_share'){
                                    handleRevenueModelChange('RSF', 1 - (locationData.absoluteRevShare / value))
                                    setLocationData(prev => ({ ...prev, splitFactor: (1 - (locationData.absoluteRevShare / value)) }));
                                }
                                
                            }
                                
                            }
                            disabled={ chargerData.length === 0 }
                        />
                </Form.Item>

                <Form.Item label="Tax (%)">
                        <InputNumber
                            style={{ width: '100%' }}
                            min={0}

                            value = {locationData.taxAmount}
                            onChange={(value) => setLocationData(prev => ({ ...prev, taxAmount: value }))}
                            disabled={ chargerData.length === 0 }
                        />
                </Form.Item>

                <div className={styles.flexContainer}>
                
                <Form.Item label="Maximum Charging Duration ( hrs ) ">
                        <InputNumber
                            min={1}
                           step={1}
                            value = {locationData.maxChargeDuration}
                            onChange={(value) => setLocationData(prev => ({ ...prev, maxChargeDuration: value }))}
                            style={{'width':'100%'}}
                        />
                </Form.Item>

                <Form.Item label="Minimum Charging Duration ( hrs ) ">
                        <InputNumber
                            min={0.25}
                           step={0.25}
                            value = {locationData.minChargeDuration}
                            onChange={(value) => setLocationData(prev => ({ ...prev, minChargeDuration: value }))}
                            style={{'width':'100%'}}
                        />
                </Form.Item>

                <Form.Item label="Grace period ( mins ) ">
                        <InputNumber
                            min={1}
                           step={1}
                            value = {locationData.gracePeriodInMinutes}
                            onChange={(value) => setLocationData(prev => ({ ...prev, gracePeriodInMinutes: value }))}
                            style={{'width':'100%'}}
                        />
                </Form.Item>



                <Form.Item label="Bookable Days Limit ( days ) ">
                    <InputNumber
                        min={1}
                        step={1}
                        value = {locationData.bookableDaysLimit}
                        onChange={(value) => setLocationData(prev => ({ ...prev, bookableDaysLimit: value }))}
                        style={{'width':'100%'}}
                    />
                </Form.Item>


                
                <Form.Item label="Allow Charger Selection ( Initiate Now )"  rules={[{ required: true, message: "Please select charger selection!" }]}>
                    <Select
                        value={locationData.selectCharger}
                        onChange={(value) => setLocationData(prev => ({ ...prev, selectCharger: value }))}
                        placeholder='Select True / False'
                    >
                            <Option key={true} value={true}>True</Option>
                            <Option key={false} value={false}>False</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="Select Related Locations"  rules={[{ required: true, message: "Please select charger selection!" }]}>
                    <Select
                        mode='multiple'
                        allowClear
                        value={locationData.relatedLocations.length === 0 ? []:locationData.relatedLocations}
                        onChange={(value) => setLocationData(prev => ({ ...prev, relatedLocations: value }))} //setLocationData(prev => ({ ...prev, relatedLocations: value }))
                        placeholder='Related Locations'
                        optionFilterProp="children"
                        disabled = {locationData.locationType === "PUBLIC" }
                    >       
                        {
                            allLocations && allLocations.map((loc)=>{
                                // console.log("location type",loc.locationType)
                                if(loc._id !== selLocation._id && loc.locationType !== "PUBLIC"){
                                return <Option key={loc._id} value={loc._id}>{loc.locationName}</Option>
                                }
                            })
                        }
                            {/* <Option key={true} value={true}>True</Option>
                            <Option key={false} value={false}>False</Option> */}
                    </Select>
                </Form.Item>

                {console.log("child loc in loc data; ", locationData)}
                
                <Form.Item label="Select Sub Locations" >
                    <Select
                        mode='multiple'
                        allowClear
                        value={locationData.childLocations}
                        onChange={(value) => setLocationData(prev => ({ ...prev, childLocations: value }))}
                        placeholder='Sub Locations'
                        optionFilterProp="children"
                    >       
                        {
                            allLocations && allLocations.map((loc)=>{
                                // console.log("location type",loc.locationType)
                                if(loc._id !== selLocation._id && loc.subLocationType !== null){ 
                                return <Option key={loc._id} value={loc._id}>{loc.locationName}</Option>
                                }
                            })
                        }
                            {/* <Option key={true} value={true}>True</Option>
                            <Option key={false} value={false}>False</Option> */}
                    </Select>
                </Form.Item>
                </div>  

                <div className={styles.DynamicRateContainer}>
                    <Form.Item label="Revenue Type" >

                <Select
                        value={tempRevenueModel.revenueType}
                        // value={locationData.revenueModel[locationData.revenueModel.length - 1].revenueType}
                        onChange={(value) => {
                            handleRevenueModelChange('revenueType',value)
                            if(value !== 'rev_share'){
                                setLocationData(prev => ({ ...prev, absoluteRevShare: 0 }))
                                setIsAbsRevShare('no')
                            }
                        }}
                        placeholder='Select Revenue Model'
                    >
                           <Option key={'rev_share'} value={'rev_share'}>Revenue Share</Option>  
                            <Option key={'per_port'} value={'per_port'}>Per Port Fee</Option>
                            <Option key={'hybrid'} value={'hybrid'}>Hybrid</Option>
                            <Option key={'muf'} value={'muf'}>MUF</Option>
                        </Select>
                    </Form.Item>


{/* {console.log("temp revenue model: ",tempRevenueModel)} */}
                    <div className={styles.flexContainer}>
                        {

                            tempRevenueModel.revenueType === 'rev_share' &&
                            <div>
                                
                                <Form.Item label="Absolute Rev Share?">
                                    <Radio.Group
                                        value={isAbsRevShare === "yes" ? 'yes' : 'no'}
                                        onChange={(e) => {
                                            setIsAbsRevShare(e.target.value)
                                            setLocationData(prev => ({ ...prev, splitFactor: 0 }))
                                            if (e.target.value === 'no') {
                                                setLocationData(prev => ({
                                                    ...prev,
                                                    absoluteRevShare: 0
                                                }))
                                                handleRevenueModelChange('RSF',0)
                                            }
                                            if (e.target.value === 'yes') {
                                                setLocationData(prev => ({ ...prev, 
                                                    absoluteRevShare: selLocation.absoluteRevShare ?
                                                        selLocation.absoluteRevShare :
                                                        0
                                                }))
                                                handleRevenueModelChange('RSF',
                                                    1 - (selLocation.absoluteRevShare / rate))
                                            }
                                            
                                        }}
                                        options={[
                                            { label: 'Yes', value: 'yes' },
                                            { label: 'No', value: 'no' },
                                        ]}
                                        optionType="button"
                                        buttonStyle="solid"
                                    />
                                </Form.Item>
                                <Form.Item label="Absolute Rev Share($)" rules={[{ required: isAbsRevShare === 'yes', message: "Please input rev share amount towards BreatheEV!" }]}>
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        min={0}
                                        max={locationData?.normalRate ? locationData?.normalRate : 100}
                                        step={0.1}
                                        placeholder="0.06"
                                        // defaultValue={0.3}
                                        disabled={isAbsRevShare === 'no'}
                                        value={locationData.absoluteRevShare}
                                        onChange={(value) => {
                                            setLocationData(prev => ({ ...prev, absoluteRevShare: value }))
                                            handleRevenueModelChange('RSF', 1 - (value / locationData.normalRate))
                                            setLocationData(prev => ({ ...prev, splitFactor: (1 - (value / locationData.normalRate)) }));
                                            // rate !== 0 ?
                                            // setLocationFormData(prev => ({ ...prev, splitFactor: (1 - (value / rate)) })) :
                                            // setLocationFormData(prev => ({ ...prev, splitFactor: 0 }))
                                        }
                                        }

                                    />

                                </Form.Item>
                                <Form.Item label="Rate/kWh ($)" rules={[{ required: isAbsRevShare === 'yes', message: "Please input rate" }]}>
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        min={0}
                                        // max={1}
                                        step={0.1}
                                placeholder="0.35"
                                // defaultValue={0.3}
                                disabled={isAbsRevShare === 'no'}
                                value={locationData.normalRate}
                                onChange={(value) => {
                                    setLocationData(prev => ({ ...prev, splitFactor: (1 - (locationData.absoluteRevShare / value)) }));
                                    setLocationData(prev => ({ ...prev, normalRate: value}));
                                    setRate(value)
                                    handleRevenueModelChange('RSF', 1 - (locationData.absoluteRevShare / value))
                                }
                                }

                            />
                        </Form.Item>
                        </div>
                        }
                        {/* {console.log("temp revenue model: ",isAbsRevShare)} */}
                        <div>
                            <Form.Item label="Split Factor" >
                                <InputNumber
                                    style={{ width: '100%' }}
                                    min={0}
                                    max={1}
                                    step={0.1}
                                    placeholder="0.6"
                                    value={tempRevenueModel.RSF}
                                    // defaultValue={0.3}
                                    // disabled={locationData.revenueModel[locationData.revenueModel.length - 1].revenueType==='per_port'}
                                    // value={locationData.revenueModel[locationData.revenueModel.length - 1].RSF}
                                    // onChange={(value) => setTempRevenueModel(prev => ({ ...prev, RSF: value }))}
                                    onChange={(value) => handleRevenueModelChange('RSF', value)}
                                    disabled={
                                        tempRevenueModel.revenueType === 'per_port' ||
                                        isAbsRevShare === 'yes'
                                        // ||
                                        // tempRevenueModel.revenueType === 'muf'
                                    }
                                    formatter={(val) => {
                                        if (val === null || val === undefined || val === '') return '';
                                        const n = typeof val === 'number' ? val : parseFloat(val);
                                        if (Number.isNaN(n) || locationData.normalRate === 0) return 0;
                                        return n.toFixed(2);
                                    }}
                                    // keep the original numeric value in state (no rounding)
                                    parser={(val) => {
                                        if (val === null || val === undefined || val === '') return null;
                                        const s = String(val).replace(/[^\d.-]/g, '');
                                        const n = parseFloat(s);
                                        return Number.isNaN(n) ? null : n;
                                    }}

                                />
                            </Form.Item>

                            <Form.Item label="Transaction Fee ($)" >
                                <InputNumber
                                    min={0}
                                    placeholder="$0.20"
                                    style={{ width: '100%' }}
                                    value={tempTransactionFeeModel.transactionFee}
                                    onChange={(value) => handleTransactionFeeModelChange(value, 'transactionFee')}
                                />
                            </Form.Item>
                        </div>

                        <div>
                            <Form.Item label="Per Port Fee"   >
                                <InputNumber
                                    min={0}
                                    placeholder="$55"
                                    style={{ width: '100%' }}
                                    value={tempRevenueModel.PPA}
                                    onChange={(value) => handleRevenueModelChange('PPA', value)}
                                    // onChange={(value) => setTempRevenueModel(prev => ({ ...prev, PPA: value }))}
                                    disabled={tempRevenueModel.revenueType === 'rev_share' || tempRevenueModel.revenueType === 'muf'}
                                // value={locationData.revenueModel[locationData.revenueModel.length - 1].PPA}
                                // onChange={handlePerPortFee}
                                // disabled={locationData.revenueModel[locationData.revenueModel.length - 1].revenueType === 'rev_share'}


                                />
                            </Form.Item>

                            <Form.Item label="Transaction Fee Percentage" >
                                <InputNumber
                                    min={0}
                                    step={0.1}
                                    placeholder="0.6"
                                    style={{ width: '100%' }}
                                    value={tempTransactionFeeModel.transactionFeeFactor}
                                    onChange={(value) => handleTransactionFeeModelChange(value, 'transactionFeeFactor')}
                                />
                            </Form.Item>
                        </div>
                        {
                            tempRevenueModel.revenueType === "muf" && (
                                <>
                                <Form.Item label="MUF Rate ($)">
                                    <InputNumber
                                        min={0}
                                        placeholder="$0.20"
                                        style={{ width: '100%' }}
                                        value={tempRevenueModel.MUFA}
                                        onChange={(value) => handleRevenueModelChange('MUFRate', value)}
                                    />
                                </Form.Item>
                                <Form.Item label = "MUF charger count">
                                    <InputNumber
                                        min={0}
                                        placeholder="2"
                                        style={{ width: '100%' }}
                                        value={tempRevenueModel.MUFChargerCount}
                                        onChange={(value) => handleRevenueModelChange('MUFChargerCount', value)}
                                    />
                                </Form.Item>
                                </>
                            )
                        }

                    </div>

                    {/* <div>
                        <Button onClick={()=>{pushRevenueModelChange()}}>Update Revenue Model Change</Button>
                    </div> */}
                    <div className={styles.miscRevShareDiv}>
                        {/* <Form.Item label="Miscellaneous Revenue Split Factor" rules={require = tempMiscRevModel.miscRevShare.length > 0} >
                            <InputNumber
                                style={{ width: '100%' }}
                                min={0}
                                max={1}
                                step={0.1}
                                placeholder="0.6"
                                value={tempMiscRevModel.miscRevShareFactor}
                                onChange={(value) =>
                                    handleMiscRevModelChange(value, 'miscRevShareFactor')}
                            // disabled={
                            //     tempRevenueModel.revenueType === 'per_port' 
                            // }
                            />
                        </Form.Item> */}
                        <Form.Item label="Miscellaneous Revenue share" >

                            {/* <Select
                            value={tempMiscRevModel.miscRevShare}
                            onChange={(value) => {
                                    console.log('misc rev share value:',value);
                                    handleMiscRevModelChange(value, 'miscRevShare')
                                }}
                                placeholder='Select Fees to share'
                                mode='multiple'
                                // disabled={
                                //     tempRevenueModel.revenueType === 'per_port'
                                // }
                            >
                            <Option key={'U_Fee'} value={'U_Fee'}>Unutililzed Time Fee</Option>
                            <Option key={'I_Fee'} value={'I_Fee'}>Idle Fee</Option>
                            <Option key={'C_Fee'} value={'C_Fee'}>Cancellation Fee</Option>
                        </Select> */}
                        {console.log("tempMiscRevModel.miscRevShare",tempMiscRevModel.miscRevShare)
                        
                        }
                        {console.log("selLocation.miscRevModel",selLocation.miscRevModel)}
                            {/* <Checkbox.Group> */}
                                <Row>
                                    <Checkbox
                                    value={'U_Fee'}
                                        checked={
                                            tempMiscRevModel.miscRevShare.includes('U_Fee')
                                        }
                                    onChange={(value) => {
                                        if (value.target.checked) {
                                            let miscArray = [...tempMiscRevModel.miscRevShare];
                                            miscArray.push('U_Fee');
                                            console.log('misc array after push:', miscArray);
                                            setTempMiscRevModel((prev) => ({ ...prev, miscRevShare: miscArray }))
                                        }
                                        if (!value.target.checked) {
                                            let miscFacArray = [...tempMiscRevModel.miscRevShareFactor]
                                                let miscShareArray = [...tempMiscRevModel.miscRevShare]
                                                miscShareArray.splice(miscShareArray.indexOf('U_Fee'), 1)
                                                miscFacArray[1] = 0
                                                setTempMiscRevModel((prev)=>({...prev,miscRevShareFactor:miscFacArray, miscRevShare:miscShareArray}) )
                                            }
                                        }}
                                    >Unutililzed Time Fee</Checkbox>
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        min={0}
                                        max={1}
                                        step={0.1}
                                        placeholder="0.0"
                                        value={tempMiscRevModel.miscRevShareFactor[1]}
                                        onChange={(value) =>
                                            handleMiscRevModelChange(value, 'miscRevShareFactorU')}
                                            disabled={ !tempMiscRevModel.miscRevShare.includes('U_Fee')}
                                    ></InputNumber>
                                </Row>
                                <Row>
                                    <Checkbox
                                    value={'I_Fee'}
                                    checked={
                                            tempMiscRevModel.miscRevShare.includes('I_Fee')
                                        }
                                        onChange={(value)=>{
                                             if(value.target.checked){
                                                let miscArray = [...tempMiscRevModel.miscRevShare];
                                                miscArray.push('I_Fee')
                                                console.log('misc array after push:',miscArray);
                                                setTempMiscRevModel((prev)=>({...prev,miscRevShare:miscArray}) )
                                            }
                                            if(!value.target.checked){
                                                let miscFacArray = [...tempMiscRevModel.miscRevShareFactor]
                                                let miscShareArray = [...tempMiscRevModel.miscRevShare]
                                                miscShareArray.splice(miscShareArray.indexOf('I_Fee'), 1)
                                                miscFacArray[0] = 0
                                                setTempMiscRevModel((prev)=>({...prev,miscRevShareFactor:miscFacArray, miscRevShare:miscShareArray}) )
                                            }
                                        }}
                                    >Idle Fee</Checkbox>
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        min={0}
                                        max={1}
                                        step={0.1}
                                        placeholder="0.0"
                                        value={tempMiscRevModel.miscRevShareFactor[0]}
                                        onChange={(value) =>
                                            handleMiscRevModelChange(value, 'miscRevShareFactorI')}
                                        disabled={ !tempMiscRevModel.miscRevShare.includes('I_Fee')}
                                    ></InputNumber>
                                </Row>
                                <Row>
                                    <Checkbox
                                    value={'C_Fee'}
                                    checked={
                                            tempMiscRevModel.miscRevShare.includes('C_Fee')
                                        }
                                        onChange={(value)=>{
                                             if(value.target.checked){
                                                let miscArray = [...tempMiscRevModel.miscRevShare];
                                                miscArray.push('C_Fee')
                                                console.log('misc array after push:',miscArray);
                                                setTempMiscRevModel((prev)=>({...prev,miscRevShare:miscArray}) )
                                            }
                                            if(!value.target.checked){
                                                let miscFacArray = [...tempMiscRevModel.miscRevShareFactor]
                                                let miscShareArray = [...tempMiscRevModel.miscRevShare]
                                                miscShareArray.splice(miscShareArray.indexOf('C_Fee'), 1)
                                                miscFacArray[2] = 0
                                                setTempMiscRevModel((prev)=>({...prev,miscRevShareFactor:miscFacArray, miscRevShare:miscShareArray}) )
                                            }
                                        }}
                                    >Cancellation Fee</Checkbox>
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        min={0}
                                        max={1}
                                        step={0.1}
                                        placeholder="0.0"
                                        value={tempMiscRevModel.miscRevShareFactor[2]}
                                        onChange={(value) =>
                                            handleMiscRevModelChange(value, 'miscRevShareFactorC')}
                                        disabled={ !tempMiscRevModel.miscRevShare.includes('C_Fee')}
                                    ></InputNumber>
                                </Row>
                                <Row>
                                    <Checkbox
                                    value={'O_Fee'}
                                    checked={
                                            tempMiscRevModel.miscRevShare.includes('O_Fee')
                                        }
                                        onChange={(value)=>{
                                             if(value.target.checked){
                                                let miscArray = [...tempMiscRevModel.miscRevShare];
                                                miscArray.push('O_Fee')
                                                console.log('misc array after push:',miscArray);
                                                setTempMiscRevModel((prev)=>({...prev,miscRevShare:miscArray}) )
                                            }
                                            if(!value.target.checked){
                                                let miscFacArray = [...tempMiscRevModel.miscRevShareFactor]
                                                let miscShareArray = [...tempMiscRevModel.miscRevShare]
                                                miscShareArray.splice(miscShareArray.indexOf('O_Fee'), 1)
                                                miscFacArray[3] = 0
                                                setTempMiscRevModel((prev)=>({...prev,miscRevShareFactor:miscFacArray, miscRevShare:miscShareArray}) )
                                            }
                                        }}
                                    >Overnight Fee</Checkbox>
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        min={0}
                                        max={1}
                                        step={0.1}
                                        placeholder="0.0"
                                        value={tempMiscRevModel.miscRevShareFactor[3]}
                                        onChange={(value) =>
                                            handleMiscRevModelChange(value, 'miscRevShareFactorO')}
                                        disabled={ !tempMiscRevModel.miscRevShare.includes('O_Fee')}
                                    ></InputNumber>
                                </Row>
                            {/* </Checkbox.Group> */}

                        </Form.Item>

                    </div>
                </div>


                <div className={styles.DynamicRateContainer}>

                <Form.Item label="Unutilization Threshold"  rules={[{ required: true, message: "Please input unutilization threshold !" }]}>
            <InputNumber
                    style={{ width: '100%' }}
                    min={0}
                    max={1}
                    step={0.1}
                    placeholder="0.7"
                    value={locationData.unutilizationThreshold}
                    onChange={(value) => setLocationData(prev => ({ ...prev, unutilizationThreshold: value }))}
                    
                />
                </Form.Item>
                 <Form.Item label="Unutilization Fee Factor"  rules={[{ required: true, message: "Please input unutilization fee factor !" }]}>
                                    <InputNumber
                                            style={{ width: '100%' }}
                                            min={1}
                                            max={100}
                                            placeholder="1%"
                                            value={locationData.unutilizationFeePercent }
                                            onChange={(value) => setLocationData(prev => ({ ...prev, unutilizationFeePercent: value }))}
                                          
                                        />
                                        </Form.Item>
                </div>





                {/* dynamic rate part  */}
                {/* {console.log("rate type in component ", rateType)} */}
                <div className={styles.DynamicRateContainer}>
                    <Form.Item label={`Dynamic Rate ( ${selLocation.timezone} )`} valuePropName="checked">
                        <div className={styles.dynamicRatesDiv}>
                            <Switch
                                checked={rateType === 'dynamic'}
                                onChange={(checked) => changeChargerRateType(checked)}
                            />
                            {!isDynamicRateAddFieldVisible ? (
                                <BsPlusCircleDotted
                                    className={`${styles.dynamicRateAddBtn} ${isDynamicRateAddFieldVisible ? styles.hideIcon : ''}`}
                                    onClick={() => { setIsDynamicRateAddfieldVisible(!isDynamicRateAddFieldVisible); }}
                                />
                            ) : (
                                <BiSolidMinusCircle
                                    className={`${styles.dynamicRateAddBtn} ${!isDynamicRateAddFieldVisible ? styles.hideIcon : ''}`}
                                    onClick={() => { setIsDynamicRateAddfieldVisible(!isDynamicRateAddFieldVisible); }}
                                />
                            )}
                        </div>
                    </Form.Item>
                    {isDynamicRateAddFieldVisible && <div className={styles.dynamicRateAdditionDiv}><DynamicTimeRangeAddition dynamicRanges={chargerDynamicRate} setDynamicRanges={setChargerDynamicRate} setIsDynamicRateAddfieldVisible={setIsDynamicRateAddfieldVisible} selLocation={selLocation} sharedFieldVisible={false} /></div>}
                    {/* {console.log("rate type while calling dynamicRates component", rateType)}
                {console.log(chargerDynamicRate)} */}
                    {rateType === "dynamic" && chargerDynamicRate && <DynamicRanges dynamicRanges={chargerDynamicRate} setDynamicRanges={setChargerDynamicRate} selLocation={selLocation} getUpdatedDynamicRanges={getUpdatedDynamicRates} sharedFieldVisible={false}/>}
                </div>

                <div className={styles.flexContainer}>
                <Form.Item label="Public" valuePropName="checked">
                    <Switch checked={locationData.public} onChange={(checked) => setLocationVisibility(checked)} />
                </Form.Item>
               
                

                <Form.Item label="Charger Allocation Configuration" >
                {/* <Radio.Group onChange={(e) => setLocationData((prev) => ({ ...prev, chargerAllocationConfiguration: e.target.value }))} value={locationData.chargerAllocationConfiguration}>
                        <Space direction='horizontal'>
                        <Radio.Button value="Random">Random based</Radio.Button>
                        <Radio.Button value="Utilization">Utilization based</Radio.Button>
                        </Space>
                        </Radio.Group> */}
                          <Space>
                        <Select
                            value={locationData.chargerAllocationConfiguration} 
                            // style={{
                            //     width: 150,
                            // }}
                            onChange={(value) => setLocationData((prev) => ({ ...prev, chargerAllocationConfiguration: value }))} // value is passed directly in onChange
                            options={[
                                {
                                    value: "Random",
                                    label: 'Random based',
                                },
                                {
                                    value: "Utilization",
                                    label: 'Utilization based',
                                }
                            ]}
                        />
                    </Space>
                </Form.Item>
               

                </div>

                {/* <Form.Item label="Shared" valuePropName="checked">
                    <Switch checked={locationData.locationType === "SHARED-PUBLIC" || locationData.locationType === "SHARED-PRIVATE"} onChange={(checked) => setLocationType(checked)} />
                </Form.Item> */}
                <div className={styles.DynamicRateContainer}>
                    <Form.Item label="Shared" valuePropName="checked">
                        <div className={styles.dynamicRatesDiv}>
                             <Switch 
                             checked={locationData.locationType === "SHARED-PUBLIC" || locationData.locationType === "SHARED-PRIVATE"}
                              onChange={(checked) => setLocationType(checked)} />
                            {!isSharedFieldVisible ? (
                                <BsPlusCircleDotted
                                    className={`${styles.dynamicRateAddBtn} ${isSharedFieldVisible ? styles.hideIcon : ''}`}
                                    onClick={() => { setIsSharedFieldVisible(!isSharedFieldVisible); }}
                                />
                            ) : (
                                <BiSolidMinusCircle
                                    className={`${styles.dynamicRateAddBtn} ${!isSharedFieldVisible ? styles.hideIcon : ''}`}
                                    onClick={() => { setIsSharedFieldVisible(!isSharedFieldVisible); }}
                                />
                            )}
                        </div>
                    </Form.Item>
                    {isSharedFieldVisible && <div className={styles.dynamicRateAdditionDiv}><DynamicTimeRangeAddition dynamicRanges={sharedTimeField} setDynamicRanges={setSharedTimeField} setIsDynamicRateAddfieldVisible={setIsSharedFieldVisible} selLocation={selLocation} sharedFieldVisible={true} setLocationData={setLocationData} /></div>}
                    {
                    (locationData.locationType === "SHARED-PUBLIC" || locationData.locationType === "SHARED-PRIVATE" ) &&
                     sharedTimeField &&
                    <DynamicRanges dynamicRanges={sharedTimeField} setDynamicRanges={setSharedTimeField} selLocation={selLocation} getUpdatedDynamicRanges={getUpdatedSharedTime} sharedFieldVisible={true} setLocationData={setLocationData}  />
                    }
                </div>
            
               
        




                <div className="col-md-12">
                    <Form.Item style={{ textAlign: 'right', marginTop:'1rem' }}>
                        <ButtonCustom isLoading={isSubmitting} text={isSubmitting ? 'Updating...' : 'Update Location'} type="submit" />
                    </Form.Item>
                </div>
            </Form>
            
        </Modal>
    );
};

export default EditLocation;
